import React from "react";
import EvaluationItem from "./EvaluationsItem";

interface EvaluationListProps {
  evaluations: {
    id: string;
    point: number;
    title: string;
    comment: string;
  }[];
  onItemClick: (evaluation: {
    id: string;
    point: number;
    title: string;
    comment: string;
  }) => void;
}

const EvaluationListItems: React.FC<EvaluationListProps> = ({
  evaluations,
  onItemClick,
}) => {
  return (
    <div className="mt-4">
      {evaluations.length > 0 ? (
        evaluations.map((evaluation) => (
          <EvaluationItem
            key={evaluation.id}
            evaluation={evaluation}
            onClick={onItemClick}
          />
        ))
      ) : (
        <p className="text-gray-500">هیچ ارزیابی موجود نیست.</p>
      )}
    </div>
  );
};

export default EvaluationListItems;
